/**
 * marker接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const markerEndpoints: ApiEndpoint[] = [
  {
    id: 'marker-create',
    method: 'POST',
    path: '/api/markers',
    name: '创建标记',
    description: '为空间添加标记',
    category: API_CATEGORIES.MARKER,
    bodyParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' },
      { name: 'markerType', type: 'string', required: true, description: '标记类型（1-50字符）' },
      { name: 'relatedId', type: 'string', required: false, description: '关联ID（最大100字符）' },
      { name: 'coordinate', type: 'object', required: true, description: '坐标（2D: {x, y}, 3D: {x, y, z}）' },
      { name: 'style', type: 'object', required: true, description: '样式配置对象' },
      { name: 'description', type: 'string', required: false, description: '描述（最大500字符）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '创建的标记信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:marker:view'
  },
  {
    id: 'marker-space',
    method: 'GET',
    path: '/api/markers/space/:spaceId',
    name: '获取空间标记',
    description: '获取指定空间的标记列表',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标记列表' }
    ]
  },
  {
    id: 'marker-detail',
    method: 'GET',
    path: '/api/markers/:id',
    name: '获取标记详情',
    description: '获取标记详细信息',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标记ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '标记详细信息' }
    ]
  },
  {
    id: 'marker-update',
    method: 'PUT',
    path: '/api/markers/:id',
    name: '更新标记',
    description: '更新标记信息',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标记ID（UUID）' }
    ],
    bodyParams: [
      { name: 'markerType', type: 'string', required: false, description: '标记类型' },
      { name: 'relatedId', type: 'string', required: false, description: '关联ID' },
      { name: 'coordinate', type: 'object', required: false, description: '坐标' },
      { name: 'style', type: 'object', required: false, description: '样式配置对象' },
      { name: 'description', type: 'string', required: false, description: '描述' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '更新后的标记信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:marker:view'
  },
  {
    id: 'marker-delete',
    method: 'DELETE',
    path: '/api/markers/:id',
    name: '删除标记',
    description: '删除标记',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标记ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:marker:view'
  },
  {
    id: 'marker-by-type',
    method: 'GET',
    path: '/api/markers/type/:markerType',
    name: '按类型获取标记',
    description: '根据标记类型获取标记列表',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'markerType', type: 'string', required: true, description: '标记类型' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标记列表' }
    ]
  },
  {
    id: 'marker-by-related',
    method: 'GET',
    path: '/api/markers/related/:relatedId',
    name: '按关联ID获取标记',
    description: '根据关联ID获取标记列表',
    category: API_CATEGORIES.MARKER,
    pathParams: [
      { name: 'relatedId', type: 'string', required: true, description: '关联ID' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标记列表' }
    ]
  },
  {
    id: 'marker-types',
    method: 'GET',
    path: '/api/markers/types',
    name: '获取标记类型列表',
    description: '获取所有可用的标记类型列表',
    category: API_CATEGORIES.MARKER,
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标记类型列表' }
    ]
  },
  {
    id: 'marker-search-area',
    method: 'POST',
    path: '/api/markers/search/area',
    name: '在区域内查找标记',
    description: '在指定区域内查找标记',
    category: API_CATEGORIES.MARKER,
    bodyParams: [
      { name: 'area', type: 'object', required: true, description: '区域定义' },
      { name: 'spaceId', type: 'string', required: false, description: '空间ID（可选）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '区域内的标记列表' }
    ]
  },
  {
    id: 'marker-batch-create',
    method: 'POST',
    path: '/api/markers/batch',
    name: '批量创建标记',
    description: '批量创建标记',
    category: API_CATEGORIES.MARKER,
    bodyParams: [
      { name: 'markers', type: 'array', required: true, description: '标记数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '创建的标记列表' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:marker:view'
  },
];
